import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';
import { RootModule } from './root.module';

if (environment.production) {
    enableProdMode();
}

if (environment.newRelic.isEnabled) {
    loadBrowserAgentScript();
}

const bootstrap = () =>
    platformBrowserDynamic().bootstrapModule(RootModule, { applicationProviders: [provideZoneChangeDetection()] });

/* "Hot Module Replacement" is enabled as described on
 * https://medium.com/@beeman/tutorial-enable-hrm-in-angular-cli-apps-1b0d13b80130#.sa87zkloh
 */

if (environment.hmr) {
    if (module['hot']) {
        hmrBootstrap(module, bootstrap); //HMR enabled bootstrap
    } else {
        console.error('HMR is not enabled for webpack-dev-server!');
        console.log('Are you using the --hmr flag for ng serve?');
    }
} else {
    bootstrap(); //Regular bootstrap
}

function loadBrowserAgentScript(): void {
    const env = environment.name;
    if (env != 'production') {
        return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;

    const fileName = 'newrelic-browser-agent.js';

    script.src = `assets/scripts/${fileName}`;
    document.head.appendChild(script);
}
